export default "__VITE_ASSET__0eb42c09__"